import React, {useState, useEffect, useCallback} from 'react';
import ModalComponent from "../ModalComponent";
import registeredComponent from "../../utils/registeredComponent";
import {Button} from 'react-bootstrap';
import {apiFetch} from 'utils';
import {connect} from "react-redux";
import {modals} from "../../ducks";
import FlashMessage from "../FlashMessage/FlashMessage";
import './styles/prompt_editor.scss';
import SAFroala from '../SAFroala/SAFroala';
import Placeholder from '../Placeholder';
import FroalaEditor from 'froala-editor';

// Component for editing basic attributes of custom fields on form templates
// Fetches the custom field from a form template, then updates the appropriate attribute and posts it back
const FieldEditor = ({fieldId, formTemplateId, dispatch}) => {

  const [field, setField] = useState({});
  const [errorMessage, setErrorMessage] = useState(null)

    useEffect(() => {
      apiFetch.get(
        {},
        'form_templates/' + formTemplateId + '/fetch_field?field_id=' + fieldId)
        .then((response) => {
          setField(JSON.parse(response.field))
        })
        .catch((response) => (setErrorMessage(response.error)))
    }, []);

    const modifyField = (modifiedText, textType) => {
      let updateField = {};
      updateField[textType] = modifiedText;
      setField(field => ({...field, ...updateField}));
     }

  const onSubmit = () => {
    apiFetch.put(
      {},
      'form_templates/' + formTemplateId,
      {field, field_id: fieldId}
    ).then(() => {
      // updates these changes in real time
      const uiFieldsToUpdate =  $("[field_id='"+ fieldId + "']");
      uiFieldsToUpdate.filter("[text_type='prompt']").html(field.prompt);
      uiFieldsToUpdate.filter("[text_type='explanation']").html(field.explanation);
      dispatch(modals.actions.hide());
    }).catch((response) => {
      setErrorMessage(response.error)
    })
  }

  const buttons = [<Button type='submit' className='btn btn-primary'
                           onClick={() => onSubmit()}>Save</Button>]

  // Fields that don't have explanations
  const NO_EXPLANATION = ['SectionField', 'SubsectionField', 'AppointmentField']


  return (
    <ModalComponent title={'Edit Field'} buttons={buttons}>
      <Placeholder.loading ready={field !== {}}>
        {errorMessage && <FlashMessage type={'danger'} message={errorMessage}/>}
        <div className={'field-editor'}>
          {field._type !== 'CommentField' &&
          <div className={'field-editor-section'}>
            <label>Prompt</label>
            <SAFroala
              value={field.prompt}
              onModelChange={value => modifyField(value, 'prompt')}
              showFormatting
              simplifiedFormatting
              hideToolbar
              className={'sa-froala-prompt'}
              froalaOptions={{
                enter: FroalaEditor.ENTER_BR
              }}
            />
          </div>
          }

          {(field._type && !NO_EXPLANATION.includes(field._type)) && <div className={'field-editor-section'}>
            <label>Explanation</label>
            <SAFroala
              value={field.explanation}
              onModelChange={value => modifyField(value, 'explanation')}
              showFormatting
              simplifiedFormatting
              hideToolbar
              className={'sa-froala-explanation'}
              froalaOptions={{
                enter: FroalaEditor.ENTER_BR
              }}
            />
          </div>}
        </div>
      </Placeholder.loading>
    </ModalComponent>
  )
}

export default registeredComponent(FieldEditor)(connect()(FieldEditor));
